
import Bandera from "./Banderas";
import { Fase, MULTIPLICADORES } from "../../shared/multiplicadores";

const limpiarNombreBandera = (nombre?: string) =>
  nombre?.replace(/\.(png|webp|jpg|jpeg|svg)$/i, "") ?? "";

interface MatchCardProps {
  partido: any;
  pred?: any;
  state: string;
  fase: Fase;
  puedePredecir: boolean;
  usuarioLogueado: boolean; // 👈 NUEVO
  onPredecir: () => void;
  onEditar?: () => void;
}



const Cards = ({
  partido,
  pred,
  state,
  fase, 
  puedePredecir,
   usuarioLogueado,
  onPredecir,
  onEditar
}: MatchCardProps) => {


  const partidoLiquidado =
  typeof partido.goles_local === "number" &&
  typeof partido.goles_visitante === "number";

const puntosObtenidos =
  pred && partidoLiquidado
    ? (() => {
        const gl = partido.goles_local;
        const gv = partido.goles_visitante;

        const aciertaResultado =
          (gl > gv && pred.prediccion_local > pred.prediccion_visitante) ||
          (gl < gv && pred.prediccion_local < pred.prediccion_visitante) ||
          (gl === gv &&
            pred.prediccion_local === pred.prediccion_visitante);

        const aciertaExacto =
          gl === pred.prediccion_local &&
          gv === pred.prediccion_visitante;

        let puntos = 0;
        if (aciertaResultado) puntos += 20;
        if (aciertaExacto)
          puntos += pred.apuesta * MULTIPLICADORES[fase];

        return puntos;
      })()
    : null;

    const formatearFecha = (fecha: string) =>
  new Date(fecha).toLocaleDateString("es-AR", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  });

const formatearHora = (fecha: string) =>
  new Date(fecha).toLocaleTimeString("es-AR", {
    hour: "2-digit",
    minute: "2-digit",
  });

const minutosRestantes = (fecha: string) =>
  Math.floor((new Date(fecha).getTime() - Date.now()) / 60000);

const estadosConVideo = ["legendaria", "esperando", "acierto-parcial"];

const tieneVideo = estadosConVideo.includes(state);

return (
  <div
    className={`match-card estado-${state} fase-${fase} ${
      (pred?.apuesta ?? 0) > 0 ? "con-apuesta" : ""
    }`}
  >
    {/* VIDEO / FONDO */}
   {/* VIDEO / FONDO */}
{tieneVideo ? (
  <video
    key={state}   // 🔥 ESTO ES LA CLAVE
    className="card-video"
    autoPlay
    loop
    muted
    playsInline
  >
     <source src={`/estados/${state}.webm`} type="video/webm" />
      <source src={`/estados/${state}.mp4`} type="video/mp4" />
   
  
  </video>
) : (
  <div className="card-bg" />
)}


{/* IMAGEN LEGENDARIA */}
{state === "legendaria" && (
  <>
    <div className="card-image" />
    <div className="card-image-blur" />
  </>
)}

<div className="card-overlay" />

<div className="card-content">

  {/* IMAGEN LEGENDARIA – MISMO TAMAÑO QUE info-panel */}
  {state === "legendaria" && (
    <div className="legendaria-image-wrapper">
      <div className="legendaria-image" />
    </div>
  )}

  {/* PANEL INFO */}
  <div className="info-panel">
    {/* HEADER PARTIDO */}
        <div className="match-header">
          <Bandera
            grupo={partido.local_grupo}
            nombre={limpiarNombreBandera(partido.local_bandera)}
            alt={partido.local_nombre}
            size={60}
          />

          <strong className="team-name">
            {partido.local_nombre}
          </strong>

          <span className="vs">VS</span>

          <strong className="team-name">
            {partido.visitante_nombre}
          </strong>

          <Bandera
            grupo={partido.visitante_grupo}
            nombre={limpiarNombreBandera(partido.visitante_bandera)}
            alt={partido.visitante_nombre}
            size={60}
          />
        </div>

        {/* FECHA */}
        {partido.fecha && (
          <small className="match-date">
            {formatearFecha(partido.fecha)} · {formatearHora(partido.fecha)} hs
          </small>
        )}

        {/* CUERPO */}
        <div className="match-prediccion">
          {pred ? (
            <>
              {/* PREDICCIÓN */}
              <div className="score-panel">
                <div className="score-pred">
                  <span>Predicción</span>
                  <strong>
                    {pred.prediccion_local} - {pred.prediccion_visitante}
                  </strong>
                </div>

                {partido.goles_local !== null && (
                  <div className="score-real">
                    <span>Resultado</span>
                    <strong>
                      {partido.goles_local} - {partido.goles_visitante}
                    </strong>
                  </div>
                )}
              </div>

              {/* PENALES */}
              {partido.ganador_id && (
                <div className="penales-info">
                  ⚽ Definido por penales ({partido.penales_local}-{partido.penales_visitante})
                </div>
              )}

              {/* ESTADO */}
              <p className={`match-status estado-${state}`}>
                {state === "esperando" && "Esperando resultado"}
                {state === "acierto-parcial" && "¡Acierto parcial!"}
                {state === "legendaria" && "¡Acierto exacto!"}
                {state === "fallo" && "Fallaste"}
              </p>

              {/* PUNTOS */}
              {puntosObtenidos !== null && (
                <div className="puntos-resultado">
                  {puntosObtenidos > 0 ? (
                    <>🏆 Ganaste <strong>{puntosObtenidos} pts</strong></>
                  ) : (
                    <>❌ No sumaste puntos</>
                  )}
                </div>
              )}

              {/* ACCIONES */}
              {onEditar && puedePredecir ? (
                <button className="edit-btn" onClick={onEditar}>
                  Editar
                </button>
              ) : !usuarioLogueado ? (
            <p className="bloqueado-text">Iniciá sesión para predecir</p>
          ) : !puedePredecir ? (
            <p className="bloqueado-text">Predicciones cerradas</p>
          ) : null
          }
            </>
          ) : puedePredecir ? (
            <>
              {/* INFO PREVIA */}
              {partido.fecha && (
                <div className="info-previa">
                  <div>📅 {formatearFecha(partido.fecha)}</div>
                  <div>⏰ {formatearHora(partido.fecha)} hs</div>

                  {minutosRestantes(partido.fecha) > 0 && (
                    <div className="cuenta-regresiva">
                      ⏳ Faltan{" "}
                      {Math.floor(minutosRestantes(partido.fecha) / 60)}h{" "}
                      {minutosRestantes(partido.fecha) % 60}m
                    </div>
                  )}
                </div>
              )}

              <button className="predecir-btn" onClick={onPredecir}>
                Predecir
              </button>
            </>
          ) : (
            <p className="bloqueado-text">Predicciones cerradas</p>
          )}
        </div>

        {/* MULTIPLICADOR LEGENDARIA */}
        {state === "legendaria" && (
          <div className="legendaria-effect">
            <video
              className="legendaria-corona"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src="/estados/corona.webm" type="video/webm" />
              <source src="/estados/corona.mp4" type="video/mp4" />
            </video>

            <span className="legendaria-multi">
              x{MULTIPLICADORES[fase]}
            </span>
          </div>
        )}

      </div>
    </div>
  </div>
);

};

export default Cards;
